import { Pedido } from '@/models/sit-pedido/pedido'
import { PaginationInput } from "@/models/sit-pedido/pagination"


interface HeaderItemTableSitPedidos {
  text: String;
  align: String;
  sortable: Boolean;
  value: String;
}

interface PaginationInputTableSitPedidos {
  id: Number;
  statuses: String[];
  tipoPedido: String;
  datasCriacao: String[];
  veiculoTransportadora: any; // TODO: Verificar se existe interface ou class de VeiculoTransportadora
}

export interface PaginationTableSitPedidos {
  input: PaginationInputTableSitPedidos;
  inputPage: PaginationInput;
}


export interface TableSitPedidos {
  header: HeaderItemTableSitPedidos[];
  content: Pedido[];
  paginate: PaginationTableSitPedidos;
  isLoading: Boolean;
  total: Number;
}

const header: HeaderItemTableSitPedidos[] = [
  {
    text: "Número",
    align: "start",
    sortable: true,
    value: "id"
  },
  {
    text: "Veículo",
    align: "start",
    sortable: true,
    value: "veiculo"
  },
  {
    text: "Tipo",
    align: "start",
    sortable: true,
    value: "tipoPedido"
  },
  {
    text: "Status",
    align: "start",
    sortable: true,
    value: "status"
  },
  {
    text: "Data do pedido",
    align: "start",
    sortable: true,
    value: "dataCriacao"
  },
  {
    text: "Ações",
    align: "start",
    sortable: false,
    value: "actions"
  }
]

const content: Pedido[] = []

const paginate: PaginationTableSitPedidos = {
  input: {
    id: null,
    statuses: null,
    tipoPedido: null,
    datasCriacao: null,
    veiculoTransportadora: {
      veiculo: {
          id: null,
          placa: null
      },
      transportadora: {
        id: null,
        cnpjSemFormate: null,
        nomefantasia: null,
        razaosocial: null
     }
    }
  },
  inputPage: {
    page: 1,
    size: 10,
    sort: ['id'],
    ascendingSort: false,
  },
}

const tableState: TableSitPedidos = {
  header,
  content,
  paginate,
  isLoading: false,
  total: 0
}

export default tableState
